import {Button, Modal} from '@yandex-delivery/blocks'
import {useI18n} from '@yandex-delivery/core/i18n'
import React from 'react'

import type {Props} from './types'

export function ConfirmModal(props: Props): React.ReactElement {
  const {open, isPending = false, children, locale, ModalProps, onSubmit, onCancel} = props
  const i18n = useI18n()

  return (
    <Modal {...ModalProps} onClose={onCancel} opened={open}>
      <div data-e2e="modal-optimize-route">
        <Modal.Header title={locale.title} />
        <Modal.Body>{children}</Modal.Body>
        <Modal.Footer>
          <Modal.Footer.Controls>
            <Button data-e2e="button-cancel" disabled={isPending} onPress={onCancel}>
              {locale.cancel || i18n('modal.confirm.cancel')}
            </Button>
            <Button data-e2e="button-save" disabled={isPending} onPress={onSubmit} variant="action">
              {locale.submit || i18n('modal.confirm.ok')}
            </Button>
          </Modal.Footer.Controls>
        </Modal.Footer>
      </div>
    </Modal>
  )
}
